import React from 'react';
import {Alert} from '@tenancy.nz/ui';

function MessageNoViewing() {
  return (
    <Alert color="info">
      There are currently no viewing times available for this property. Please
      let us know your preferred viewing times below and we will be in touch.
    </Alert>
  );
}

export default MessageNoViewing;
